// Shared PO screen constants. The SO Type list drives both the generation filter (PoGenerate) and
// the PO listing filter (ViewPo); it mirrors the OMS PurchaseOrderGenerateType enum.

export const KAM_MODULE_CODE = 4;

// SAO leg of the SAO-CN settlement flow (advance supply at PTS, rate difference settled later by a
// credit note). KAM-only — the OMS rejects it for any other module/company.
export const SO_TYPE_SAO_CN = "SAO-CN";

export const SO_TYPE_OPTIONS = [
    { name: "Regular", code: "Regular" },
    { name: "SAO", code: "SAO" },
    { name: "CNRP", code: "CNRP" },
    { name: "CNSH", code: "CNSH" },
    { name: "SHPO", code: "SHPO" },
    { name: SO_TYPE_SAO_CN, code: SO_TYPE_SAO_CN },
];

// PO types whose POs can be submitted to the company. Mirrors PO_SUBMIT_ALLOWED_TYPES in the OMS
// (src/api/po/po.utility.ts) — CN-related types (CNRP, CNSH) are never submittable.
export const PO_SUBMIT_ALLOWED_TYPES = ["Regular", "SAO", "SHPO", SO_TYPE_SAO_CN];

// FALLBACK ONLY. Which SO Types are allowed per module now comes from the OMS config table
// module_order_type_hdr via GET /po/reconciliation-module-types; this list is used solely when
// that call has not resolved (or failed), so the screen is not left with an empty dropdown.
// Note these are the numeric CNDN codes (po_hdr.order_cndn_remarks_hdr), not type names — the
// reconciliation screen and the generation filter use different encodings.
export const RECONCILIATION_SO_TYPE_OPTIONS = [
    { name: "Regular", code: "1" },
    { name: "SAO", code: "2" },
    { name: "CNRP", code: "3" },
    { name: SO_TYPE_SAO_CN, code: "6" },
];

// M10-15780. Discriminator the OMS puts on a blocked PO-generation response (HTTP 200 with
// success:false, because the OMS error handler cannot carry a structured list). Mirrors
// validation_type in backend-oms-svc generatePOWithFiltersController.
export const PO_VALIDATION_PRODUCT_CONFIG_MISSING = "PRODUCT_CONFIG_MISSING";
